var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyright = function SvgCopyright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.945 12.36q-1.011 0-1.76-.352a3.5 3.5 0 0 1-1.217-.939q-.484-.6-.733-1.32A4.6 4.6 0 0 1 4 8.312v-.264q0-.748.235-1.467.249-.719.733-1.29A3.7 3.7 0 0 1 6.2 4.352Q6.933 4 7.916 4t1.76.367q.792.366 1.261 1.041.485.66.543 1.57h-1.35a1.9 1.9 0 0 0-.674-1.218q-.572-.498-1.54-.499-.836 0-1.393.382-.557.381-.836 1.041T5.408 8.18q0 .807.279 1.481.278.66.836 1.056.572.382 1.422.382.66 0 1.144-.235a2.1 2.1 0 0 0 .778-.63q.293-.397.352-.895h1.349q-.044.924-.543 1.598-.484.675-1.29 1.056-.792.367-1.79.367"
  })));
};
export default SvgCopyright;